export default "__VITE_ASSET__DV8eOiZC__"